module.exports = __webpack_public_path__ + "img/dementia-adventure.7a799bf3.png";